<template>
  <div class="row">
    <div class="col-md-4">
      <div class="row pb-4">
        <div class="col-md-12">
          <CloudAccelerator
            :plan="plan"
            :plan-status="planStatus"
            :site="site"
            :site-status="siteStatus"
            namespace="sites"
          />
        </div>
      </div>
      <div class="row pb-4">
        <div class="col-md-12">
          <PurgeCache
            :plan="plan"
            :plan-status="planStatus"
            :site="site"
            :site-status="siteStatus"
            namespace="sites"
          />
        </div>
      </div>
      <div class="row pb-4">
        <div class="col-md-12">
          <CloudAutoScaling
            :plan="plan"
            :plan-status="planStatus"
            :site="site"
            :site-status="siteStatus"
          />
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="row pb-2">
        <div class="col-md-12">
          <PerformanceMonitoring
            :plan="plan"
            :plan-status="planStatus"
            :site="site"
            :site-status="siteStatus"
          />
        </div>
      </div>
      <div v-if="site" class="row pb-2">
        <div class="col-md-12">
          <Cdn :plan="plan" :site="site" :site-status="siteStatus" namespace="sites" />
        </div>
      </div>
      <div class="row pb-4">
        <div class="col-md-12">
          <Bandwidth
            :plan="plan"
            :plan-status="planStatus"
            :site="site"
            :site-status="siteStatus"
          />
        </div>
      </div>
      <div class="row pb-4">
        <div class="col-md-12">
          <PhpFpm :plan="plan" :plan-status="planStatus" :site="site" :site-status="siteStatus" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bandwidth from "@/components/smart/cards/Bandwidth";
import Cdn from "@/components/smart/cards/Cdn";
import CloudAccelerator from "@/components/smart/cards/CloudAccelerator";
import CloudAutoScaling from "@/components/smart/cards/CloudAutoScaling";
import { computed } from "@vue/composition-api";
import PerformanceMonitoring from "@/components/smart/cards/PerformanceMonitoring";
import PhpFpm from "@/components/smart/cards/PhpFpm";
import PurgeCache from "@/components/smart/cards/PurgeCache";
import store from "@/store";

export default {
  name: "PlanPerformancePage",
  components: {
    Bandwidth,
    Cdn,
    CloudAccelerator,
    CloudAutoScaling,
    PerformanceMonitoring,
    PhpFpm,
    PurgeCache,
  },
  setup() {
    const plan = computed(() => store.getters["plans/getItem"]);
    const planStatus = computed(() => store.getters["plans/getItemStatus"]);
    const site = computed(() => store.getters["plans/getPrimarySite"]);
    const siteStatus = computed(() => store.getters["plans/getPrimarySiteStatus"]);

    return {
      plan,
      planStatus,
      site,
      siteStatus,
    };
  },
};
</script>
